import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getWaterUseStatusList as getWaterUseStatusListApi,
	getWaterUseStatusListQuery as getWaterUseStatusListQueryApi,
	getWaterUseStatus as getWaterUseStatusApi,
	addNewWaterUseStatusApi,
	updateWaterUseStatusApi,
	deleteWaterUseStatusApi,
	checkWaterUseStatusExistsApi,
} from '../../helpers/water_use_status/api_helper';

export const getWaterUseStatusList = createAsyncThunk(
	'waterUseStatus/getWaterUseStatusList',
	async () => {
		try {
			const response = await getWaterUseStatusListApi();
			// Extract data array from response
			return response.data || response;
		} catch (error) {
			toast.error('Error al obtener los estados de uso.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const getWaterUseStatusListQuery = createAsyncThunk(
	'waterUseStatus/getWaterUseStatusListQuery',
	async params => {
		try {
			const response = getWaterUseStatusListQueryApi(params);
			return response;
		} catch (error) {
			throw new Error(error);
		}
	}
);

export const getWaterUseStatus = createAsyncThunk(
	'waterUseStatus/getWaterUseStatus',
	async water_use_status_id => {
		try {
			const response = await getWaterUseStatusApi(water_use_status_id);
			return response;
		} catch (error) {
			toast.error('Error al obtener el estado de uso.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const addNewWaterUseStatus = createAsyncThunk(
	'waterUseStatus/addNewWaterUseStatus',
	async water_use_status => {
		try {
			const response = await addNewWaterUseStatusApi(water_use_status);
			toast.success('Estado de Uso agregado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al agregar el estado de uso.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const updateWaterUseStatus = createAsyncThunk(
	'waterUseStatus/updateWaterUseStatus',
	async water_use_status => {
		try {
			const response = await updateWaterUseStatusApi(water_use_status);
			toast.success('Estado de Uso actualizado exitosamente.', {
				autoClose: 3000,
			});
			// Extract data from response if it's wrapped
			return response.data || response;
		} catch (error) {
			toast.error('Error al actualizar el estado de uso.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const deleteWaterUseStatus = createAsyncThunk(
	'waterUseStatus/deleteWaterUseStatus',
	async water_use_status => {
		try {
			const response = await deleteWaterUseStatusApi(water_use_status._id);
			toast.success('Estado de Uso eliminado exitosamente.', {
				autoClose: 3000,
			});
			// Return the original object to identify which item to remove
			return water_use_status;
		} catch (error) {
			toast.error('Error al eliminar el estado de uso.', {
				autoClose: 3000,
			});
			throw new Error(error);
		}
	}
);

export const checkWaterUseStatusExists = createAsyncThunk(
	'waterUseStatus/checkWaterUseStatusExists',
	async name => {
		try {
			const response = await checkWaterUseStatusExistsApi(name);
			return response;
		} catch (error) {
			return { exists: false };
		}
	}
);
